<template>
    <div class="menu-role-management body-box">
        <div class="left">
            <Tree :switchVal="searchParams.isDown" :showSwitch='true'  @changeSwitch="changeSwitch" @nodeClick="nodeClick"></Tree>
        </div>
        <div class="right">
            <TabelSearch :searchConfig="searchConfig"   :searchParams="searchParams" @resetCallBack="resetCallBack" @search="setSearchParams"></TabelSearch>
            <Table :width="'100%'"
                   :tableLoading="tableLoading"
                   :tabelButtons="tabelButtons"
                   :templateData="tableTemplateData"
                   :tableConfig="tableConfig"
                   :pagination="pagination">
            </Table>
        </div>
        <el-dialog
                :close-on-click-modal="false" :close-on-press-escape="false"
            :title="title"
            :visible.sync="dialogVisible"
            width="700px"
            :before-close="handleClose">
           <div style="display: flex;height: 500px;overflow: hidden;">
			   <TreeSelect v-if="!isEdit&&dialogVisible" @nodeCheck="nodeCheck"></TreeSelect>
               <editForm ref="editForm" :formConfig="formConfig" :ruleForm="ruleEditForm" :rules="rulesEdit" :buttonConfig="buttonConfig"></editForm>
           </div>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false" :close-on-press-escape="false"
                title="权限绑定"
                :visible.sync="dialogVisible2"
                width="500px"
                :before-close="handleClose2">
                <div class="" style="height: 500px;overflow: auto">
                    <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" class="demo-ruleForm">
						<el-form-item prop="permissionIdList">
							<el-tree ref="roleTree" default-expand-all :check-strictly="checkStrictly" :data="roleData" :highlight-current="true" :current-node-key="nodeId" node-key="id" :props="defaultProps" show-checkbox  @check-change="handleCheckChange"> </el-tree>
						</el-form-item>
                    </el-form>
                </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose2">取 消</el-button>
                <el-button type="primary" @click="submitForm2()">确 定</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
    import Table from "../../../../components/table/table";
    import TabelSearch from '../../../../components/tabel-search/tabel-search';
    import editForm from '../../../../components/edit-form/edit-form';
    import {systemApi} from "../../../../api-path/system-api";
    import Tree from '../../../../components/Tree/nodeTree';
    import TreeSelect from '../../../../components/Tree/nodeTreeSelect.vue';
    export default {
        components:{
            Table,TabelSearch,editForm,Tree,TreeSelect
        },
        name: "menu-role-management",
        data(){
            return{
				isEdit:false,
				areaId:'',
				areaName:'',
                checkStrictly:true,
                nodeId:[],
                roleData:[],
                options:[],
                title:'',
                defaultProps:{
                    label: 'name',
                    children: 'sourceTreeDTOList'
                },
                props: {
                    label: 'name',
                    children: 'sourceTreeDTOList'
                },
                count: 1,
                ruleForm:{
                    jurisdictionArea:null,//选择权限区域
                    roleName:'',//角色名称
                    userType:[],
                },
                ruleForm2:{
                    areaId:'',
                    isRegionalAuth:false,
                    permissionIdList:[],
                    roleId:''
                },

                rules2:{
                    bindingResources:[{ required: true, message: '请选择绑定资源', trigger: 'blur' }],
                },
                dialogVisible:false,
                dialogVisible2:false,
                searchParams: {
                    name:'',//关键词
                    areaId:'',
                    isDown:false,
                    page:1,
                    size:15,
                },
                searchConfig: {
                    dataName: 'searchParams',
                    items: [
                        {
                            key: 'name',
                            placeholder: '请输入关键词',
                        },
                    ]
                },
                //表格
                tableLoading: false,
                tableTemplateData: [],
                tabelButtons: [
                    {
                        type: 'add',
                        code:'ADD',
                        fn: () => {
                            this.title='新增角色';
							this.isEdit=false;
                            this.dialogVisible=true;
                            // this.ruleEditForm.areaId=this.areaId
                            // this.ruleEditForm.areaName=this.areaName
                        }
                    },
                ],
                tableConfig: {
                    checkbox: true,
                    checkboxFn: (data)=>{ console.log(data) },
                    rows: [
                        {
                            label: '角色名称',
                            prop: 'name',
                        }, {
                            label: '所属区域',
                            prop: 'areaName',
                        },{
                            label: '备注',
                            prop: 'intro',
							width:'150px',
							type: "popover",
                        }
                    ],
                    rowButtons:{
                        width:'300px',
                        items: [
                            {
                                label: '编辑',
                                fn:(data)=> {
                                    this.title='编辑角色'
                                    this.$http.get(systemApi.getRoleDetail,{params:{id:data.id}}).then(res=>{
                                        if(res.status==200){
											let areaName=res.result.names.map(item=>{
												return item.name
											})
											let areaIds=res.result.names.map(item=>{
												return item.centerId
											})
                                                let obj={
                                                    areaName:areaName.toString(),
                                                    areaId:areaIds.toString(),
                                                    intro:data.intro,
                                                    id:data.id,
                                                    name:data.name,
                                                    userType:data.userType.split(','),
                                                }
                                                this.ruleEditForm=obj;
												this.isEdit=true;
                                                this.dialogVisible=true;
                                        }
                                    })

                                }
                            },
                            {
                                label: '删除',
                                // code:'del',
                                type: 'danger',
                                fn: (data)=>{
                                    this.delData(data.id)
                                },
                            },
                            {
                                show:'isTrue==true?true:false',
                                label: '权限配置',
                                fn:(data)=> {
                                    let $this=this;
                                    $this.dialogVisible2=true;
                                    this.checkStrictly=true;
                                    $this.roleData=JSON.parse(localStorage.getItem('ur')).sourceTreeDTOList[0].sourceTreeDTOList
                                    $this.$http.get(systemApi.roleResourceTree,{params:{
                                          id:data.id,
                                          isRegionalAuth:false,
                                      }}).then(res=>{
                                           if(res.status==200){
                                               let result=[];
                                               res.result.forEach(res=>{
                                                   result.push(res.id)
                                               })
                                               this.ruleForm2.roleId=data.id;
                                               this.$nextTick(function () {

                                                   this.$refs['roleTree'].setCheckedKeys(result);
                                                   setTimeout(()=>{
                                                       this.checkStrictly=false;
                                                   },1000)
                                               })


                                               // $this.$refs.roleTree.setCurrentKey(result)
                                           }
                                      })
                                }
                            },

                        ],
                    },
                },
                pagination: {
                    show: true,
                    total: 0,
                    page: 1,
                    size: 15,
                    sizeChange: this.sizeChange,
                    pageChange: this.pageChange,
                }, // 分页
                ruleEditForm: {
                    areaId:'',
                    areaName:'',
                    id:'',
                    name:'',
                    userType:[],
                },
                rulesEdit:{
                    areaName:[{ required: true, message: '选择权限区域', trigger: 'blur' }   ],
                    name:[{ required: true, message: '请输入角色名称', trigger: 'blur' }],
                    userType:[{ required: true, message: '请选择角色类型', trigger: 'blur' }],
                },
				choosedArea:[],//选择的区域
                buttonConfig: {
                    validateAll: ['editForm'],
                    buttons: [{
                        type: 'save', // 保存
                        fn: (data) => {
                            console.log(data);
                            let newData= JSON.parse(JSON.stringify(data))
                            newData.userType=newData.userType.join(',')
                            this.$http.post(systemApi.saveRole,newData).then(res=>{
                               if(res.status==200){
                                   this.$message.success('角色添加成功');
                                   this.handleClose()
                                   this.startSearch();
                               }
                           })
                        },
                    }, {
                        type: 'back', // 返回
                        fn: () => {
                           this.handleClose()
                        }
                    }, ]
                },
                formConfig: {
                    disabled: false,
                    items: [
                        [
                            {
                                valueType: 'text', // 类型
                                label: '权限区域',
                                key: 'areaName', // 数据名称
                                prop: 'areaName', // 验证规则
                                labelWidth: "140px", // label 宽度
                                itemWidth: '100%',
								disabled:true,
                                placeholder: '请选择权限区域', // 提示信息
                                fn:(data)=>{}
                           }
                           ],
                          [
                              {
                                  valueType: 'input', // 类型
                                  label: '角色名称',
                                  key: 'name', // 数据名称
                                  prop: 'name', // 验证规则
                                  labelWidth: "140px", // label 宽度
                                  itemWidth: '50%',
                                  maxlength: 50,
                                  placeholder: '请输入角色名称', // 提示信息
                              }
                          ],
                        [
                            {
                                valueType: 'checkbox', // 类型
                                label: '角色类型',
                                key: 'userType', // 数据名称
                                prop: 'userType', // 验证规则
                                labelWidth: "140px",  // label 宽度
                                itemWidth: '100%',
                                options: {label: 'label',value: 'value'},
                                data: [
                                    {label: '接警员',value: '1' },
                                    {label: '出警员',value: '2'},
                                    {label: '开通区域授权',value: '3' }
                                ],
                            }],
                        [
                            {
                                valueType: 'textarea', // 类型
                                label: '备注',
                                key: 'intro', // 数据名称
                                prop: 'intro', // 验证规则
                                labelWidth: "140px", // label 宽度
                                itemWidth: '100%',
                                maxlength: 50,
                                rows:2,
                                placeholder: '请输入备注(最长50个字节)', // 提示信息
                            }
                        ]


                    ]
                },

            }
        },
        created() {
            this.startSearch();
        },
        beforeRouteLeave(to, form, next) {
            sessionStorage.removeItem('area');
            sessionStorage.removeItem('switch');
            next()
        },
        methods:{
            resetCallBack(){
				this.searchParams.areaId=this.areaId;
				this.searchParams.isDown=this.isDown;
				this.searchParams.name="";
				this.searchParams.page=this.pagination.page=1;
				this.searchParams.size=this.pagination.size=15;
                this.startSearch();
            },
            startSearch() { //查询表格数据
                let _this=this;
                _this.tableLoading = true;
                _this.tableTemplateData=[];
                _this.searchParams.nodeId=JSON.parse(sessionStorage.getItem('area'))
                _this.$http.get(systemApi.getRoleList,{params:_this.searchParams}).then(res=>{
                    _this.tableLoading = false;
                    if(res.status==200){
                        res.result.pageList.forEach((item)=>{
                            if(item.userType.indexOf('1')!=-1){
                                item.isTrue=true;
                            }
                            _this.tableTemplateData.push(item)
                        })
                        _this.pagination.total=res.result.total;
                    }
                })
            },
            // 设置查询参数
            setSearchParams(data) {
                this.searchParams = {...this.searchParams, ...data}
                this.pagination.page = this.searchParams.page = 1
                this.startSearch()
            },
            handleClose(){ //关闭模态框
                this.dialogVisible=false;//关闭模态框
                this.ruleEditForm= {
                        areaId:'',
                        areaName:'',
                        id:'',
                        name:'',
                        userType:[],
                };
            },
            nodeClick(node) {
                this.searchParams.areaId = node.id;
                // this.ruleEditForm.areaId= node.id;
                // this.ruleEditForm.areaName=node.name;
                this.ruleForm2.areaId=node.id;
				this.areaId=node.id;
				this.areaName=node.id?node.name:"";
                this.startSearch()
            },
            changeSwitch(e){
                this.searchParams.isDown=e;
				this.isDown=e;
                this.startSearch()
            },
			nodeCheck(value){
				// this.choosedArea=value;
				console.log(value);
				this.ruleEditForm.areaId=value.ids.toString();
				this.ruleEditForm.areaName=value.names.toString();
			},
            submitForm2(){
                this.ruleForm2.permissionIdList= this.$refs['roleTree'].getCheckedKeys()
                if( this.ruleForm2.permissionIdList.length>0){

                    this.$http.post(systemApi.roleAuthorization,this.ruleForm2).then(res=>{
                        if(res.status==200){
                            this.$message.success('权限绑定成功');
                            this.handleClose2()
                            this.startSearch();
                        }
                    })
                }else {
                    this.$message.error('请选择角色权限')
                }


            },
            handleClose2(){
                this.dialogVisible2=false;//关闭模态框
                this.$refs['ruleForm2'].resetFields();//情况表单
                this.$refs.roleTree.setCheckedKeys([]);//清除选中
            },

            // 每页显示条数
            sizeChange(size) {
                this.pagination.size = this.searchParams.size = size
                this.startSearch()
            },
            // 当前页
            pageChange(page) {
                this.pagination.page = this.searchParams.page = page
                this.startSearch()
            },
            handleCheckChange(data, checked, indeterminate) {
                console.log(data, checked, indeterminate);
            },
            delData(id){
                this.$confirm('此操作将删除该角色数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.delete(systemApi.deleteRole,{params:{id:id}}).then((res)=>{
                        if(res.status == 200){
                            this.$message.success('刪除成功');
                            this.startSearch()
                        }
                    })
                }).catch(() => { });
            },


        }
    }
</script>

<style scoped lang="less">
   .menu-role-management{
		margin-left: 10px;
		box-sizing: border-box;
		height: 100%;
		padding: 10px;
		border-radius: 10px;
		background: #fff;
		display: flex;
       .left {
           margin-right: 10px;
           border-right: 1px solid #c1c1c1;
       }
       .right {
           flex: 1;
           display: flex;
           flex-direction: column;
       }
   }
</style>
